/* eslint-disable eslint-comments/disable-enable-pair, security/detect-object-injection */
import {
  SET_LAST_SEEN_OFFERS,
  SET_SAVED_OFFERS,
  SET_APPLIED_OFFERS,
  REMOVE_LAST_SEEN_OFFER,
  SET_AGREEMENT,
  TOGGLE_LAST_SEEN_OFFER_FAVOURITE_STATUS,
  TOGGLE_SAVED_OFFER_FAVOURITE_STATUS
} from 'src/redux/actions/offers';
import { SET_TAB } from 'src/redux/actions/tabs';


const initialState = {
  hasProfilingAgreement: true,
  processing: false,
  lastSeenOffers: [],
  savedOffers: [],
  appliedOffers: []
};

const offersReducer = (state = initialState, { type, payload }) => (
  {
    [TOGGLE_LAST_SEEN_OFFER_FAVOURITE_STATUS]: () => ({
      ...state,
      lastSeenOffers: state.lastSeenOffers.map(offer => ({
        ...offer,
        isFavourite:
          offer.offerId === payload.offerId ? payload.isFavourite : offer.isFavourite
      }))
    }),
    [TOGGLE_SAVED_OFFER_FAVOURITE_STATUS]: () => ({
      ...state,
      savedOffers: state.savedOffers.filter(
        offer => offer.offerId !== payload.offerId
      )
    }),
    [REMOVE_LAST_SEEN_OFFER]: () => ({
      ...state,
      lastSeenOffers: state.lastSeenOffers.filter(
        ({ offerId }) => offerId !== payload.offerId
      )
    }),
    [SET_LAST_SEEN_OFFERS]: () => ({
      ...state,
      ...payload,
      processing: false
    }),
    [SET_APPLIED_OFFERS]: () => ({ ...state, ...payload, processing: false }),
    [SET_SAVED_OFFERS]: () => ({ ...state, ...payload, processing: false }),
    [SET_TAB]: () => ({ ...state, processing: true }),
    [SET_AGREEMENT]: () => ({ ...state, ...payload })
  }[type] || (() => state)
)();

export default offersReducer;
